/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import { lazySetRelatedSectionInNotesFeed } from "../index";
import type ClientItem from "owa-mail-store/lib/store/schema/ClientItem";

export function dispatchReadingPaneCurrentItemToNotesSDK(item: ClientItem): void {
    lazySetRelatedSectionInNotesFeed.importAndExecute(item);
}
